import { render, staticRenderFns } from "./ModalSlot.vue?vue&type=template&id=530d64d4&"
import script from "./ModalSlot.vue?vue&type=script&lang=js&"
export * from "./ModalSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports